<div *ngIf="isContract()">
  <div>
    <span class="font-app-bold text-darkest text-sm md:text-base">
      {{ "generalOptions.title" | translate }}
    </span>
  </div>
</div>
<div class="flex justify-between py-2 text-sm">
  <span class="font-app-regular text-dark text-sm md:text-base">
    {{ "optionsList.formula" | translate }}
  </span>
  <span class="font-app-regular text-darkest text-sm md:text-base">
    {{ details.formulasAndOptionsInformations.formulaName }}
  </span>
</div>
@if (details.formulasAndOptionsInformations?.formulaCode === packagesType.Essentielle) {
  @for (en of enhancements; track $index) {
    <div class="flex justify-between py-2 text-sm">
      <span class="font-app-regular text-dark text-sm md:text-base">
        {{ en.label }}
      </span>
      <span class="font-app-regular text-darkest text-sm md:text-base">
        {{ en.value | currency: "EUR" : "symbol" : "1.0" : "fr" }}
      </span>
    </div>
  }

  <!-- FRANCHISE -->
  <div class="flex justify-between py-2 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.franchise" | translate }}
    </span>

    <span class="font-app-regular text-darkest text-sm md:text-base">
      {{ details.formulasAndOptionsInformations.franchise | currency: "EUR" : "symbol" : "1.0" : "fr" }}
    </span>
  </div>
} @else {
  <div class="flex justify-between py-2 text-sm">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "optionsList.capital" | translate }}
    </span>
    <span class="font-app-regular text-darkest text-sm md:text-base">
      {{ details.formulasAndOptionsInformations.caracteristics[0].value | currency: "EUR" : "symbol" : "1.0" : "fr" }}
    </span>
  </div>
  <!--Objet de valeur pour Confort+-->
  <div>
    <div>
      <div class="flex w-full">
        <div class="w-full">
          <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
            {{ details.formulasAndOptionsInformations.caracteristics[1].label }}
          </span>
        </div>
        <p class="w-full text-right text-darkest">
          {{
            details.formulasAndOptionsInformations?.caracteristics[1]?.value | currency: "EUR" : "symbol" : "1.0" : "fr"
          }}
          <!-- @if (details.formulasAndOptionsInformations?.caracteristics[1]?.pricedAmountTTC !== null) {
          <span>
            (+{{
              details.formulasAndOptionsInformations?.caracteristics[1]?.pricedAmountTTC
                | currency: "EUR" : "symbol" : "" : "fr"
            }}{{ "optionsList.month" | translate }})
          </span>
        } -->
          <!-- @if (
          details.formulasAndOptionsInformations?.caracteristics[1]?.isIncluded &&
          details.formulasAndOptionsInformations?.caracteristics[1]?.pricedAmountTTC === null
        ) {
          {{ "optionsList.included" | translate }}
        } -->
        </p>
      </div>
    </div>
  </div>
}

<div
  *ngIf="isContract()"
  class="flex items-end mt-3">
  <div class="items-center justify-between w-full">
    <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
      "lessorInformations.sendCertificate" | translate
    }}</span>
  </div>
  <span class="text-sm md:text-base font-app-regular text-darkest">
    {{
      (!details.optionalServicePolicyVm.sendCertificationOption ? "generalOptions.no" : "generalOptions.yes")
        | translate
    }}
  </span>
</div>
<p-divider type="solid"></p-divider>
